import { type NodeViewProps } from '@tiptap/core';
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { useEffect } from 'react';

import { setupParagraphAttributes } from './content-paragraph';

export function ContentBlockQuoteView(props: NodeViewProps) {
  const { textAlign } = props.node.attrs;

  useEffect(
    function () {
      const timeoutId = setTimeout(function () {
        setupParagraphAttributes(props.getPos, props.node, props.editor);
      }, 50);
      return function () {
        clearTimeout(timeoutId);
      };
    },
    [props]
  );

  return (
    <NodeViewWrapper className="group relative flex items-start justify-end justify-self-center">
      <div
        className="font-body-2-m absolute -left-6 top-1 flex h-1.5 w-1.5 select-none items-center justify-center bg-slate-100 text-branding-gray-600 group-hover:hidden"
        contentEditable={false}
      >
        B
      </div>
      <NodeViewContent
        className="w-full max-w-[800px] border-l-4 border-l-branding-gray-200 px-4 py-1 text-2xl font-extralight"
        style={textAlign == null ? {} : { textAlign: textAlign as string }}
      />
    </NodeViewWrapper>
  );
}
